import { Component, Inject, OnInit } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Utils } from "../../../utils/utils";
import { DefaultValuesService } from "../../../services/defaultvalues.service";

@Component({
    selector: "monitoringdevops",
    templateUrl: './monitoringdevops.component.html',
    styleUrls: ['../../../style/container-tab-list.component.less'],
    standalone: false
})




export class MonitoringDevOpsComponent {

    title: string;

    constructor(
        private defaults: DefaultValuesService
    ) {
        this.title = "DevOps Monitoring";
    }

}